module.exports = __webpack_public_path__ + "static/media/Group76.75c23bf4.webp";